import Footer from 'components/footer';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom';

const MobileFooterLayout: React.FC = () => {
    const [active, setActive] = useState("");
    const isMobile = useMediaQuery({ maxWidth: 767 });

    const location = useLocation();

    useEffect(() => {
      if(window.location.pathname === '/v1/' || window.location.pathname === '/v1/home'){
        setActive('footerImg1');
      }
      else if(window.location.pathname === '/v1/profile/portfolio'){
        setActive('footerImg2');
      }
      else if(window.location.pathname.includes( '/v1/profile')){
        setActive('footerImg3');
      }
    }, [location])
    
    return (<div>

        {isMobile && <Footer>
            <div id="globalFooter" style={ { display: "visible" } }>
            <div className="footer-div">
                <a href="/v1/home" onClick={() => setActive("footerImg1")}>
                    <div >
                        <div className="footerIconDiv">
                            <div className={ `footerImg1 ${active === "footerImg1" ? "redFooterIcon" : ""}` } id="homePageIcon"></div>
                        </div>
                        <p className={ active === "footerImg1" ? "footer-text redFooterIcon" : "footer-text" }id="homePageText">Explore</p>
                    </div>
                </a>
                <a href="/v1/profile/portfolio" onClick={() => setActive("footerImg2")}>
                    <div >
                        <div className="footerIconDiv" style={ { position: "relative" } }>
                            <div  className={ active === "footerImg2" ? "footerImg2 redFooterIcon" : "footerImg2" } id="advisorPageIcon"></div>
                        </div>
                        <p className={ active === "footerImg2" ? "footer-text redFooterIcon" : "footer-text" } id="advisorPageText">Dashboard</p>
                    </div>
                </a>
                <a href="/more" onClick={() => setActive("footerImg3")}>
                    <div >
                        <div className="footerIconDiv">
                            <div  className={ active === "footerImg3" ? "footerImg3 redFooterIcon" : "footerImg3" } id="morePageIcon"></div>
                        </div>
                        <p className={ active === "footerImg3" ? "footer-text redFooterIcon" : "footer-text" } id="morePageText">Profile</p>
                    </div>
                </a>
                <div style={ { clear: "both" } }></div>
            </div></div>
            </Footer>}
    </div>);
}

export default MobileFooterLayout;